import { Menu } from "antd";
import { ToolbarButton } from "shared/types/adLibrary";
import { keys } from "shared/types/shared";
import { ToolbarButtonKey } from "shared/types/toolbar";
import styles from "./ContextTableActions.module.scss";
import { parseContextMenuActions } from "./utils";
import { MenuInfo } from "rc-menu/lib/interface";

const isActionDestructive = (itemKey: ToolbarButtonKey) => {
  const destructiveActions: ToolbarButtonKey[] = ["Delete"];
  return destructiveActions.includes(itemKey);
};
export interface Props<T> {
  getItemsToRender: (record: T) => ToolbarButton;
  record: T;
}

export function ContextTableActions<T>({ getItemsToRender, record }: Props<T>) {
  const parsedItems = parseContextMenuActions(getItemsToRender, record);

  const handleClick = (
    handler:
      | ((e: React.MouseEvent<HTMLElement, MouseEvent>) => void)
      | ((info: MenuInfo) => void)
      | undefined,
    e: React.MouseEvent<HTMLElement, MouseEvent> | MenuInfo,
  ) => {
    if (!handler) return;

    if ("key" in e) {
      (handler as (info: MenuInfo) => void)(e as MenuInfo);
    } else {
      (handler as (e: React.MouseEvent<HTMLElement, MouseEvent>) => void)(
        e as React.MouseEvent<HTMLElement, MouseEvent>,
      );
    }
  };
  return (
    <div className={styles.container}>
      <Menu
        selectedKeys={[]}
        data-cy="context-table-actions"
        forceSubMenuRender
      >
        {keys(parsedItems).map(itemKey => {
          const menuText = parsedItems[itemKey]?.extraInfo?.title
            ? parsedItems[itemKey]?.extraInfo?.title
            : itemKey;
          const handler = parsedItems[itemKey]?.onClick;
          return (
            <Menu.Item
              className={styles.menuItem}
              key={itemKey}
              style={isActionDestructive(itemKey) ? { color: "red" } : {}}
              onClick={e => handleClick(handler, e)}
              disabled={parsedItems[itemKey]?.disabled}
            >
              {parsedItems[itemKey]?.icon}
              {menuText}
            </Menu.Item>
          );
        })}
      </Menu>
    </div>
  );
}
